<template>
  <button @click="handleLogin" class="login-btn">
    <GoogleIcon />
    Login
  </button>
  
  <CustomPopup 
    :show="popup.show" 
    :type="popup.type" 
    :title="popup.title" 
    :message="popup.message" 
    @close="closePopup" 
  />
</template>

<script setup>
import { ref } from 'vue'
import { auth, provider } from "@/firebase"
import { signInWithPopup } from 'firebase/auth'
import { createOrGetUser } from '../services/userService'
import { isEmailBlacklisted } from '../config/blacklist'
import GoogleIcon from './GoogleIcon.vue'
import CustomPopup from './CustomPopup.vue'

const emit = defineEmits(['login-success', 'login-error'])
const popup = ref({ show: false, type: '', title: '', message: '' })

const handleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, provider)
    if (!result.user.email.endsWith("@nordeus.com")) {
      showPopup('error', 'Access Denied', 'Please use your @nordeus.com email to access this application.')
      return
    }
    if (isEmailBlacklisted(result.user.email)) {
      showPopup('error', 'Access Denied', 'Your account has been restricted from accessing this application.')
      return
    }
    await createOrGetUser(result.user)
    emit('login-success', result.user)
  } catch (error) {
    console.error("Login failed:", error)
    showPopup('error', 'Login Failed', 'Unable to sign in. Please try again.')
    emit('login-error', error)
  }
}

const showPopup = (type, title, message) => {
  popup.value = { show: true, type, title, message }
}

const closePopup = () => {
  popup.value.show = false
}
</script>

<style scoped>
.login-btn {
  padding: 12px 24px;
  background: #e53e3e;
  color: white;
  border: 2px solid white;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
}

.login-btn :deep(.google-icon) {
  background: white;
  border-radius: 50%;
  padding: 2px;
}

.login-btn:hover {
  transform: translateY(-2px) scale(1.05);
  background: white;
  color: #e53e3e;
  border-color: #e53e3e;
}
</style>